export const selectReservationState = (state) => state.reservation;
export const selectAteliers = (state) => selectReservationState(state).ateliers;
export const selectZones = (state) => selectReservationState(state).zones;
export const selectCreneaux = (state) => selectReservationState(state).creneaux;
export const selectCreneauxJour = (state) =>
  selectReservationState(state).creneauxJour;
export const selectReservationLoading = (state) =>
  selectReservationState(state).loading;
export const selectReservationLoadingByKey = (state) =>
  selectReservationState(state).loadingByKey;
export const selectReservationError = (state) =>
  selectReservationState(state).error;
export const selectReservationStatus = (state) =>
  selectReservationState(state).reservationStatus;
export const selectReservationResponse = (state) =>
  selectReservationState(state).reservationResponse;
export const selectReservationDetails = (state) =>
  selectReservationState(state).reservationDetails;
